import React from "react";
import { useState } from "@vrf/fr-vrf-core-react";
import { AddCmpProjectDialogContext, addCmpProjectDialogInitialState } from ".";

export const AddCmpProjectDialogStateProvider = ({ children }: any) => {
  const [pageState, setPageState] = useState(addCmpProjectDialogInitialState);
  const context = {
    pageState: pageState,
    setPageState: setPageState,
  };
  return (
    <AddCmpProjectDialogContext.Provider value={context}>
      {children}
    </AddCmpProjectDialogContext.Provider>
  );
};
